import { reportToSentry } from "~/utils/errors/sentryReport";

type ErrorLike = Error | ErrorEvent | PromiseRejectionEvent;

export default async function errorSent(
  type = "",
  code = "",
  details: Record<string, unknown> = {},
  event: ErrorLike | null = null,
) {
  reportToSentry(type, code, details, event);
}
